import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { NewVersionBanner, staleNavigationGuard } from "@/lib/version-check";

type RouterContext = {
	queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
	beforeLoad: staleNavigationGuard,
	component: RootRoute,
});

function RootRoute() {
	return (
		<>
			<NewVersionBanner />
			<Outlet />
		</>
	);
}
